// Validação de CPF/CNPJ pelo dígito verificador.
//
// Por que importa: o Bling rejeita CPFs/CNPJs com dígito errado
// retornando a mensagem genérica "Não foi possível salvar o contato",
// sem dizer qual campo está errado. Validar localmente evita a ida
// desnecessária à API e dá feedback claro pro gerente.

// Tira tudo que não for dígito
function digitos(s) { return (s || '').toString().replace(/\D/g, '') }

// Bloqueia sequências como 00000000000, 11111111111 etc (passariam no
// cálculo dos dígitos mas são inválidas pela Receita)
function ehSequenciaRepetida(d) {
  return /^(\d)\1+$/.test(d)
}

// Calcula um dígito verificador (CPF/CNPJ) — soma ponderada mod 11
function calcularDV(digs, pesos) {
  let soma = 0
  for (let i = 0; i < pesos.length; i++) soma += Number(digs[i]) * pesos[i]
  const resto = soma % 11
  return resto < 2 ? 0 : 11 - resto
}

// True se o CPF é válido pela Receita (11 dígitos, não repetido, DVs OK)
export function validarCPF(valor) {
  const d = digitos(valor)
  if (d.length !== 11) return false
  if (ehSequenciaRepetida(d)) return false
  const dv1 = calcularDV(d, [10, 9, 8, 7, 6, 5, 4, 3, 2])
  if (dv1 !== Number(d[9])) return false
  const dv2 = calcularDV(d, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2])
  if (dv2 !== Number(d[10])) return false
  return true
}

// True se o CNPJ é válido (14 dígitos, não repetido, DVs OK)
export function validarCNPJ(valor) {
  const d = digitos(valor)
  if (d.length !== 14) return false
  if (ehSequenciaRepetida(d)) return false
  const dv1 = calcularDV(d, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  if (dv1 !== Number(d[12])) return false
  const dv2 = calcularDV(d, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2])
  if (dv2 !== Number(d[13])) return false
  return true
}

// Despacha pra validar conforme tipoDocumento. Vazio = válido (o
// `min(11)` do schema cuida do obrigatório separadamente).
export function validarDocumento(valor, tipo) {
  const d = digitos(valor)
  if (!d) return true
  if (tipo === 'CNPJ') return validarCNPJ(d)
  return validarCPF(d)
}
